import Swiper, { Navigation, Pagination, A11y } from 'swiper';

export default () => {



    const testimonialsSwiper = new Swiper('#testimonials-section-slider', {
        modules: [Navigation, Pagination, A11y],
        navigation: {
            nextEl: '.arrow-next__testimonials',
            prevEl: '.arrow-prev__testimonials',
        },
        a11y: true,
        keyboardControl: true,
        grabCursor: true,
        loop: false,
        watchOverflow: false,
        breakpoints: {
            1200: {
                slidesPerView: 2.2,
                spaceBetween: 0,
                centeredSlides: false,
            },
            2000: {
                slidesPerView: 3.2,
                spaceBetween: 0,
                centeredSlides: false,
            },
        },
    });

    const testimonialsSwiper2 = new Swiper('#testimonials-section-slider-mobile', {
        modules: [Navigation, Pagination, A11y],
        navigation: {
            nextEl: '.arrow-next__testimonials-mobile',
            prevEl: '.arrow-prev__testimonials-mobile',
        },
        a11y: true,
        keyboardControl: true,
        grabCursor: true,
        loop: false,
        breakpoints: {
            320: {
                slidesPerView: 1.08,
                spaceBetween: 0,
            },
            768: {
                slidesPerView: 1.2,
                spaceBetween: 0,
            },
            850: {
                slidesPerView: 1.2,
                spaceBetween: 0,
            },
            992: {
                slidesPerView: 2.2,
                spaceBetween: 0,
            },
        },
    });

    function updateSwipers() {
        testimonialsSwiper.update();
        testimonialsSwiper2.update();
    }

    let resizeDebouncer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeDebouncer);
        resizeDebouncer = setTimeout(updateSwipers, 250);
    });
};